module.exports = __webpack_public_path__ + "img/img-inicio.920f9243.png";